import { createAction } from '@reduxjs/toolkit';
import { responseFailed } from './error';

export const getUserInformation = createAction('user/getUserInformation', function prepare() {
  return {
    payload: {
      endPoint: 'user',
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: getUserInformationSuccess,
      failure: responseFailed,
      version: '1.2.0'
    }
  };
});

export const getUserInformationSuccess = (response) => (dispatch) => {
  dispatch(getUserInformationSuccessResponse(response));
};

export const getUserInformationSuccessResponse = createAction(
  'user/getUserInformationSuccess',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

export const updateUserEmailAddress = createAction(
  'user/updateUserEmailAddress',
  function prepare(email) {
    return {
      payload: {
        endPoint: 'user/details/email',
        method: 'put',
        body: {
          email
        },
        isPaasApi: true,
        addHeader: true,
        success: updateUserEmailAddressSuccess,
        failure: responseFailed,
        version: '1.2.0'
      }
    };
  }
);

export const updateUserEmailAddressSuccess = createAction(
  'user/updateUserEmailAddressSuccess',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

/**
 * @todo probably doesn't need a payload if the payload is null
 */
export const userNameSubmitted = createAction('user/userNameSubmitted', function prepare() {
  return {
    payload: null
  };
});
